import React, { useState, useEffect } from "react";
import client from '../contentfulClientToken';
import { Link } from 'react-router-dom';

// Custom hook to detect mobile devices
const useMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
};


const ArchiveList = ({
    yearsIsVisible,
    setYearsIsVisible,
    monthsIsVisible,
    setMonthsIsVisible,
    keywordsIsVisible,
    setKeywordsIsVisible
}) => {
    const isMobile = useMobile();
    const [months, setMonths] = useState([]);

    useEffect(() => {
        client.getEntries({
            content_type: 'month'
        })
            .then(response => {
                setMonths(response.items);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    return (
        <>


            <div id="archiveButton" >
                <p className="years-button" onClick={() => {
                    setYearsIsVisible(v => !v);
                    setMonthsIsVisible(false);
                    setKeywordsIsVisible(false);
                }}><img src="./content/handwriting/years.png" alt="" /></p>
                <p className="months-button" onClick={() => {
                    setMonthsIsVisible(v => !v);
                    setYearsIsVisible(false);
                    setKeywordsIsVisible(false);
                }}><img src="./content/handwriting/months.png" alt="" /></p>
                <p className="keywords-button" onClick={() => {
                    setKeywordsIsVisible(v => !v);
                    setYearsIsVisible(false);
                    setMonthsIsVisible(false);
                }}><img src="./content/handwriting/themes.png" alt="" /></p>
            </div>

            {monthsIsVisible && (
                <div className="archiveContainer months-list">
                    <ul id="archiveList">
                        {months.sort((a, b) => b.fields.number - a.fields.number).map(month => (
                            <li key={month.sys.id} onClick={() => setMonthsIsVisible(false)}>
                                {/* <Link to={month.fields.url}>{month.fields.date}</Link> */}
                                {isMobile ? (
                                    /*   <Link to={month.fields.url}>{month.fields.date}</Link> */
                                    <Link to={month.fields.url}>
                                        <img src={month.fields.titreManuscrit.fields.file.url} alt={month.fields.date} />
                                    </Link>
                                ) : (
                                    <Link to={month.fields.url}>
                                        <img src={month.fields.titreManuscrit.fields.file.url} alt={month.fields.date} />
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            {keywordsIsVisible && (
                /*       <ul className="archiveContainer keywords-list" onClick={() => setKeywordsIsVisible(false)}>
                          <li>
                              <Link to="/people">People</Link>
                          </li>
                          <li>
                              <Link to="/japan">Japan</Link>
                          </li>
                          <li>
                              <Link to="/nature">Nature</Link>
                          </li>
                          <li>
                              <Link to="/city">City</Link>
                          </li>
                          <li>
                              <Link to="/iceland">Iceland</Link>
                          </li>
                          <li>
                              <Link to="/hospital">Hospital</Link>
                          </li>
                          <li>
                              <Link to="/europe">Europe</Link>
                          </li>
                          <li>
                              <Link to="/water">Water</Link>
                          </li>
                          <li>
                              <Link to="/text">Text</Link>
                          </li>
                          <li>
                              <Link to="/renovation">Renovation</Link>
                          </li>
                      </ul> */

                <ul className="archiveContainer keywords-list" onClick={() => setKeywordsIsVisible(false)}>


                    <li>
                        <Link to="/people"><img src={'./content/handwriting/people.png'} alt="People" /></Link>
                    </li>
                    <li>
                        <Link to="/japan"><img src={'./content/handwriting/japan.png'} alt="Japan" /></Link>
                    </li>
                    <li>
                        <Link to="/nature"><img src={'./content/handwriting/nature.png'} alt="Nature" /></Link>
                    </li>

                    <li>
                        <Link to="/hospital"><img src={'./content/handwriting/hospital.png'} alt="Hospital" /></Link>
                    </li>
                    <li>
                        <Link to="/europe"><img src={'./content/handwriting/europe.png'} alt="Europe" /></Link>
                    </li>
                    <li>
                        <Link to="/water"><img src={'./content/handwriting/water.png'} alt="Water" /></Link>
                    </li>
                    <li>
                        <Link to="/thoughts"><img src={'./content/handwriting/thoughts.png'} alt="Thoughts" /></Link>
                    </li>
                    <li>
                        <Link to="/city"><img src={'./content/handwriting/city.png'} alt="City" /></Link>
                    </li>
                    <li>
                        <Link to="/iceland"><img src={'./content/handwriting/iceland.png'} alt="Iceland" /></Link>
                    </li>
                    <li>
                        <Link to="/chateautimo"><img src={'./content/handwriting/chateau-timo-02.png'} alt="Chateau Timo" /></Link>
                    </li>
                </ul>


            )}
            {yearsIsVisible && (
                <ul className="archiveContainer year-list" onClick={() => setYearsIsVisible(false)}>
                    <li>
                        <Link to="/2026"><img src={'./content/handwriting/years/2026.png'} alt="2026" /></Link>
                    </li>
                    <li>
                        <Link to="/2025"><img src={'./content/handwriting/years/2025.png'} alt="2025" /></Link>
                    </li>
                    <li>
                        <Link to="/2024"><img src={'./content/handwriting/years/2024.png'} alt="2024" /></Link>
                    </li>
                    <li>
                        <Link to="/2023"><img src={'./content/handwriting/years/2023.png'} alt="2023" /></Link>
                    </li>
                    <li>
                        <Link to="/2022"><img src={'./content/handwriting/years/2022.png'} alt="2022" /></Link>
                    </li>
                    <li>
                        <Link to="/2021"><img src={'./content/handwriting/years/2021.png'} alt="2021" /></Link>
                    </li>
                    <li>
                        <Link to="/2020"><img src={'./content/handwriting/years/2020.png'} alt="2020" /></Link>
                    </li>
                    <li>
                        <Link to="/2019"><img src={'./content/handwriting/years/2019.png'} alt="2019" /></Link>
                    </li>
                    <li>
                        <Link to="/2018"><img src={'./content/handwriting/years/2018.png'} alt="2018" /></Link>
                    </li>
                    <li>
                        <Link to="/2017"><img src={'./content/handwriting/years/2017.png'} alt="2017" /></Link>
                    </li>
                    <li>
                        <Link to="/2016"><img src={'./content/handwriting/years/2016.png'} alt="2016" /></Link>
                    </li>
                    <li>
                        <Link to="/2015"><img src={'./content/handwriting/years/2015.png'} alt="2015" /></Link>
                    </li>
                </ul>
            )}
        </>
    );
};

export default ArchiveList;